import Vue from 'vue'
import { Notification, MessageBox, InputNumber, Form, FormItem } from 'element-ui'
import { Dialog } from 'quasar'
import pc_widget from 'src/widgets/index'
Vue.use(pc_widget)
Vue.component('ElInputNumber', InputNumber)
Vue.component('ElForm', Form)
Vue.component('ElFormItem', FormItem)
Vue.prototype.$ELEMENT = { zIndex: 6000 }
Vue.prototype.$dialog = function (message = '删除后，将不能恢复！确定删除吗？', html, cancel, ok) {
    return new Promise((resolve, reject) => {
        Dialog.create({
            title: '提示',
            message,
            cancel: '关闭',
            ok: '确定',
            html,
        }).onOk(() => {
            resolve(true)
        }).onCancel(() => {
            reject(false)
        })
    })
}
Vue.prototype.$confirm = MessageBox.confirm
function message(e) {
    if (!e) return
    if (typeof e == 'string') {
        Notification({
            title: e,
            type: 'info',
        })
    } else {
        Notification(e)
    }
}
message['html'] = (val, desc) => Notification({ title: val, message: desc , dangerouslyUseHTMLString: true,})
message['success'] = (val, desc) => Notification.success({ title: val, message: desc })
message['warning'] = (val, desc) => Notification.warning({ title: val, message: desc })
message['error'] = (val, desc) => Notification.error({ title: val, message: desc })
Vue.prototype.$message = message
// Vue.use(ElementUI);
// export default ({ app }) => {
//   Vue.use(ElementUI, {
//     i18n: (key, value) => app.i18n.t(key, value),
//   });
// };
